import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { SubscriptionInfo } from 'shared/providers/subscription-info/domain/models/subscription-info';
import { useLazyGetSubscriptionInfoQuery } from 'shared/providers/subscription-info/domain/reducers/subscription-queries';

import { useExpireNoficationsMutation } from 'features/notification/domain/notification-queries/notification-queries';

export interface ISubscriptionInfoHook {
  subscriptionInfo: SubscriptionInfo | undefined;
  isFinishedExpireNotifications: boolean;
}

const useSubscriptionInfo = (): ISubscriptionInfoHook => {
  const { isAuthenticated } = useAuth();
  const { data: subscriptionInfo, refetch: fetchSubscriptionInfo } = useLazyGetSubscriptionInfoQuery();
  const {
    mutate: executeExpireNotificationsMutation,
    isSuccess: isSuccessExpireNotifications,
    isError: isErrorExpireNotifications,
    reset: resetExpireNotificationsMutation,
  } = useExpireNoficationsMutation();
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      fetchSubscriptionInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (subscriptionInfo) {
      setIsFinished(false);
      resetExpireNotificationsMutation();
      executeExpireNotificationsMutation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionInfo]);

  useEffect(() => {
    if (isSuccessExpireNotifications || isErrorExpireNotifications) {
      setIsFinished(true);
    }
  }, [isSuccessExpireNotifications, isErrorExpireNotifications]);

  return {
    subscriptionInfo,
    isFinishedExpireNotifications: isFinished,
  };
};

export default useSubscriptionInfo;
